<template>
    <div>
        <div class="select_t">
            <span style="color:#666;line-height: 30px;">类型：</span>
            <span :class="selectCurrent==index?'spanActiveMain':'spanText'" v-for="(item, index) in selectTop" :key="index" @click="searchSelectMain(index,item)">{{item.name}}</span>
        </div>
        <div v-if="bookList.length==0">
            <a-empty style="margin-top:200px;" />
        </div>
        <div v-else>
            <ul  class="bookList">
                <li class="bookDetail" v-for="(item,index) in bookList" :key="index" @click="lookDetail(item)">
                    <div class="title">{{item.title}}
                        <a-button class="btn" v-if="item.status=='0'||item.status=='2'" @click.stop="goNext(item)">{{format.textEditButton(item.status)}}</a-button>
                        <span class="textStatusType">{{format.textStatusType(item.status)}}</span>
                    </div>
                    <div class="content" v-html="item.content"></div>
                    <div class="userDetail">
                        <img class="userPhoto" src="../../assets/teacherRoad/13.png" alt="" />
                        <span class="userName">{{item.authorName}}</span>
                        <!-- <img class="classImg" src="../../assets/teacherRoad/14.png" alt="" />
                        <span class="classType">{{format.articleType(item.articleType)}}</span> -->
                        <span class="date">{{format.format(item.createDate)}}</span>
                    </div>
                </li>
            </ul>
            <div style="text-align:center;margin-top:20px;height:50px;">
                <a-config-provider>
                <a-pagination
                    show-quick-jumper
                    :default-current="1"
                    :page-size="pageSize"
                    @change="handleListChange"
                    show-less-items
                    :total=total />
                </a-config-provider>
            </div>
        </div>

    </div>
</template>

<script>
import format from '@/utils/format.js'
import writeBookVue from './writeBook.vue'
// const _this = this
export default {
  name: 'mySnailBookList',
  data () {
    return {
      format,
      selectTop: [{ name: '全部', id: '' }, { name: '已发布', id: 3 }, { name: '审核中', id: 1 }, { name: '未通过', id: 2 }, { name: '草稿箱', id: 0 }],
      selectCurrent: 0,
      pageSize: 10,
      pageNum: 1,
      total: 1,
      articleType: '',
      bookList: [],
      bookStatus: '' // 空全部 1审核中 0未审核 2未通过 3 已发布
    }
  },
  mounted () {
    // this.bookStatus = this.$route.query.status
    this.getList()
  },
  watch: {
    $route () {
      // this.bookStatus = this.$route.query.status
      this.getList()
    }
  },
  methods: {
    // 分页获取文章列表/ebook/teacher/article/getMyArticleList
    getList () {
      const param = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        status: this.articleType
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/article/getMyArticleList',
        body: param
      }).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.bookList = res.resultData
          // this.total = res.resultData.total
        }
      })
    },
    searchSelectMain (index, item) {
      this.selectCurrent = index
      this.articleType = item.id
      this.getList()
    },

    handleListChange (current, pageSize) {
      this.pageNum = current
      this.pageSize = pageSize
      this.getList()
    },
    lookDetail (item) {
      sessionStorage.setItem('snailsID', item.id)
      this.$router.push({ name: 'snailBookListDetail' })
    },
    goNext (item) {
      console.log(item)
      if (item.content) {
        this.$router.push({ name: 'writeBook', query: { item } })
      }
      if (!item.content && item.fileList) {
        this.$emit('editWord', item)
      }
    }
  }
  // beforeRouteEnter(to,form,next){
  //     console.log(to)
  //     debugger
  //     if(form.name=='snailBookListDetail'){
  //         _this.$router.push({name: 'snailBookListDetail'})
  //     }
  //     if(to.name=='snailBookList'){
  //         _this.$router.push({name: 'snailBookList'})
  //     }
  //     next()
  // }
}
</script>

<style lang="less" scoped>
    ul,li{
        list-style: none;
        margin: 0;
        padding: 0;
    }
    .select_t{
        cursor: pointer;
        padding: 0 50px;
        line-height: 50px;
        .spanText{
            display: inline-block;
            padding: 0 10px;
            height: 24px;
            line-height:24px;
            color: #000;
            font-size: 14px;
            text-align: left;
        }
    }
    .bookList{
        min-height: 600px;
        .bookDetail{
            cursor: pointer;
            margin-top: 15px;
            border-bottom: 1px solid #F0F0F0;
            padding: 0 50px;
            .title{
                font-size: 16px;
                font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
                font-weight: 500;
                color: #000000;
                line-height: 32px;
                height: 32px;
                .textStatusType{
                    float: right;
                    color:#999;
                    font-size: 14px;
                }
                .btn{
                    float: right;
                    color:#999;
                    font-size: 14px;
                    margin-left:10px;
                    border: 1px solid @primary-color;
                    color:@primary-color;
                    height: 24px;
                    line-height: 24px;
                    margin-top: 4px;
                    // width: 100px;
                    padding: 0px;
                }
            }
            .content{
                font-size: 14px;
                font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
                font-weight: 400;
                color: #000000;
                width: 700px;
                line-height: 30px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
            }
            .userDetail{
                    height: 30px;
                    line-height: 30px;
                    margin-bottom: 10px;
                .userPhoto{
                    width: 12px;
                    height: 12px;
                }
                .userName{
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                    margin-left: 5px;
                }
                .classImg{
                    width: 12px;
                    height: 12px;
                    margin-left: 10px;
                }
                .classType{
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                    margin-left: 5px;
                }
                .date{
                    float: right;
                    font-size: 12px;
                    font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
                    font-weight: 400;
                    color: #999999;
                }
            }
        }
    }
    .spanActiveMain{
        display: inline-block;
        padding: 10px;
        height: 24px;
        line-height: 24px;
        border-radius: 16px;
        color: @primary-color;
        font-size: 18px;
        font-weight: 600;
        text-align: left;
        cursor: pointer;
    }
</style>
